<mat-card>
    <mat-card-header data-html2canvas-ignore>
        <mat-card-title>
            <h2>
                {{'partitions.tree.title.shortLabel' | translate}}
                <app-tooltip text="{{'partitions.tree.title.summary' | translate}}"></app-tooltip>
            </h2>
        </mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <app-partitions-tree
            [partitions]="partitions"
            [selectedNode]="selectedNode"
            [isMultiple]="isMultiple"
            [allowMultiCategories]="allowMultiCategories"
            (toggleSelection)="toggleSelection.emit($event)"></app-partitions-tree>
    </mat-card-content>
</mat-card>
